import React from "react";
import { CustomizedAlert } from "./CustomizedAlert";

export const Home = () => {
  return (
    <CustomizedAlert
      status="info"
      text="Please launch Check from within a course."
    />
  );
};
